import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { IoCloseCircle } from "react-icons/io5";
import { Box, Typography } from '@mui/material';

export default function ApproveModal(props) {

    const getTotalAmount = () => {
        if (props.data&&props.open) {
            let add = props.data.agent_details.reduce((acc, curr) => acc + curr.rm_amount, 0);
            return add
        }
    }

    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <Box sx={{ position: 'absolute', top: 5, right: 5, cursor: 'pointer', fontSize: '20px' }} onClick={props.handleClose}>
                    <IoCloseCircle />
                </Box>

                <DialogContent>
                    <DialogContentText >
                        <Typography variant='h4'> Payment  of  {getTotalAmount()} will be deducted from your wallet balance</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        props.isLoading ?
                            <Button disabled variant='contained' color='secondary' size='small' onClick={props.handleClose}>
                                Loading...
                            </Button>
                            :
                            <Button variant='contained' color='secondary' size='small' onClick={props.handleApprove}>
                                Click to approve
                            </Button>
                    }

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
